/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { MdOutlineAirplanemodeInactive } from 'react-icons/md';

function NoSearchResults({ title, message, children }) {
  return (
    <section className="no-search-results app-container mt-3 p-3 d-flex flex-column justify-content-center align-items-center">
      <div className="no-search-results__plane">{children}</div>
      <div className="search-info--item_value mb-3">{title}</div>
      <div className="secondary-text">{message}</div>
    </section>
  );
}

NoSearchResults.defaultProps = {
  title: 'No Flights Found',
  message: 'Please change your search criteria and try again',
  children: <MdOutlineAirplanemodeInactive />,
};

NoSearchResults.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.any,
};

export default NoSearchResults;
